{
  "filters": {
    "creationDate": {
      "label": "Date d'ajout",
      "formatter": {
        "input": "YYYY-MM-DD",
        "tag": "DD/MM/YYYY"
      },
      "periodSeparator": "au",
      "placeholder": "Sélectionner une période"
    },
    "searchByNameOrVersion": "Recherche par nom ou version",
    "range": "Type d’équipements",
    "status": "Statut"
  },
  "newFirmware": "Ajouter un nouveau firmware",
  "noFirmware": "Aucun firmware n'est disponible",
  "column": {
    "versionName": "Nom de la version",
    "type": "Type",
    "declination": "Gamme",
    "version": "Version",
    "buildDate": "Date de génération",
    "creationDate": "Date d'ajout",
    "dateFormat": "DD/MM/YYYY à HH:mm",
    "status": "Statut"
  },
  "actions": {
    "activate": {
      "label": "Activer le firmware",
      "description": "Le firmware {name} va être activé."
    },
    "deactivate": {
      "label": "Désactiver le firmware",
      "description": "Le firmware {name} va être désactivé."
    },
    "delete": {
      "label": "Supprimer le firmware",
      "description": "Le firmware {name} va être supprimé.",
      "descriptionEmbedded": "Le firmware {name} est actuellement utilisé dans une campagne ou une opération. Sa suppression impactera ces opérations."
    }
  },
  "status": {
    "ACTIVATED": "Actif",
    "DEACTIVATED": "Inactif"
  },
  "section": {
    "informations": {
      "title": "Informations du firmware"
    },
    "compatibility": {
      "title": "Compatibilité du firmware"
    },
    "complements": {
      "title": "Compléments"
    }
  },
  "validation": {
    "name": "Le nom du firmware est obligatoire",
    "version": "La version du firmware est obligatoire"
  },
  "form": {
    "name": "Nom de la version",
    "description": "Description",
    "version": "Version",
    "range": "Type",
    "declination": "Gamme",
    "hardwareVersions": "Versions hardware",
    "firmwareVersions": "Versions firmware",
    "status": "Statut",
    "minimalCompatibleFirmwareVersion": "Version minimale compatible du firmware"
  },
  "upload": {
    "title": "Sélectionner un fichier",
    "browse": "Parcourir",
    "restrictionInformation": "Le firmware déposé doit être une archive au format ZIP et doit peser moins de 750 Mo.",
    "validation": {
      "fileMandatory": "Le fichier doit être au format ZIP.",
      "fileEmpty": "L'archive ne doit pas être vide.",
      "fileSize": "La taille du fichier doit être inférieure à 750 Mo."
    }
  },
  "firmwareInfo": {
    "compatibility": {
      "title": "Compatibilité",
      "description": "Le firmware sélectionné a les dépendances suivantes :"
    },
    "equipmentTypeAttached": "Type d’équipement attaché au firmware",
    "compatibleHardwareVersions": "Versions de hardware compatibles",
    "compatibleFirmwareVersions": "Versions de firmware compatibles"
  },
  "selected": "Firmware sélectionné :"
}
